import { render, staticRenderFns } from "./MannerScoreView.vue?vue&type=template&id=00ce80b9&"
import script from "./MannerScoreView.vue?vue&type=script&lang=js&"
export * from "./MannerScoreView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports